import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { MainLayoutComponent } from "./shared/layout/app-layouts/main-layout.component";
import { AuthLayoutComponent } from "./shared/layout/app-layouts/auth-layout.component";
import { AuthGuard } from "./core/guards/auth.guard";
import { RoleResolveService } from "./core/resolver/role-resolve.service";

const routes: Routes = [
  {
		path: "", redirectTo: 'auth', pathMatch: 'full',
	},
  {
    path: "",
    component: MainLayoutComponent,
    data: { pageTitle:"" },
    children: [{
        path: "profile",
        loadChildren: () => import('./features/auth/user-profile/user-profile.module').then(m => m.UserProfileModule),
        data: { pageTitle: "profile_myProfile", right: 'accounts.profile.' },
        canActivate: [AuthGuard],
        // resolve:{
        //   profile: RoleResolveService
        // }
      }]
  },
  {
    path: "mask",
    loadChildren: () => import('./shared/loading-mask/loading-mask.module').then(m => m.LoadingMaskModule),
  },
  {
    path: "mask/:continue",
    loadChildren: () => import('./shared/loading-mask/loading-mask.module').then(m => m.LoadingMaskModule),
  },
  {
    path: "auth",
    component: AuthLayoutComponent,
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule),
  },
  { path: "**", redirectTo: "auth"}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy'})],
  exports: [RouterModule],
  providers: [RoleResolveService]
})
export class AppRoutingModule {}